import { FormControl, FormErrorMessage, FormLabel, InputGroup, Switch } from '@chakra-ui/react';
import React, { FC, useRef } from 'react';

import { FieldComponentProps } from './types';

type SwitchFieldProps = FieldComponentProps<boolean> & {
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

export const SwitchField: FC<SwitchFieldProps> = (props) => {
  const {
    id,
    label,
    disabled,
    value,
    onChange,
    error,
    helperText,
    required,
    size = 'md',
  } = props;
  const fieldRef = useRef<HTMLDivElement>(null);

  return (<InputGroup height='100%'>
    <FormControl 
      display='flex' 
      alignItems='center'
      gap={2}
      isRequired={required}
      isInvalid={error}
      isDisabled={disabled}
      ref={fieldRef}
    >
      <FormLabel htmlFor={id} m={0} textColor="dark.300">{label}</FormLabel>
      <Switch 
        id={id} 
        position="relative"
        isChecked={value || false}
        onChange={(e) => onChange(e.target.checked)}
        size={size}
      />
      {error && <FormErrorMessage>{helperText}</FormErrorMessage>}
    </FormControl>
  </InputGroup>);
};

export default SwitchField;


